import { api } from '@shared/api';

import { useMutation } from '@tanstack/react-query';

type MutationProps = {
  jobUuid: string;
};

const useDownloadMarginTransactionReport = () =>
  useMutation({
    mutationFn: ({ jobUuid }: MutationProps) =>
      api.endpoints.downloadMarginTransactionReportJob({ params: { jobUuid } }),
  });

export { useDownloadMarginTransactionReport };
